import * as React from "react";
import { Price } from "@grandvisionhq/common";
/* empty css                             */
const ConfigurationTotalPrice = ({
  originalPrice,
  discountedPrice,
  pricePrefix,
  ...rest
}) => /* @__PURE__ */ React.createElement("div", { className: "configuration-total-price-wrapper" }, discountedPrice && discountedPrice !== originalPrice && /* @__PURE__ */ React.createElement(
  Price,
  {
    ...rest,
    type: "strikethrough",
    value: originalPrice,
    className: "configuration-total-price"
  }
), /* @__PURE__ */ React.createElement(
  Price,
  {
    ...rest,
    value: discountedPrice ?? originalPrice,
    className: "configuration-total-price",
    type: discountedPrice ? "discount" : "default",
    prefix: pricePrefix
  }
));
export {
  ConfigurationTotalPrice
};
//# sourceMappingURL=ConfigurationTotalPrice.js.map
